/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostSimulationStopSingleByIdParams,
  PostSimulationStopExtendedByIdParams,
  PostSimulationSingleByIdParams,
  PostSimulationExtendedByIdParams,
  PostGuestSimulationStopSingleByIdParams,
  PostGuestSimulationSingleByIdParams,
  PostSimulationSingleByIdQuery,
  PostSimulationExtendedByIdQuery,
  PostSimulationStopSingleByIdResponse,
  PostSimulationStopExtendedByIdResponse,
  PostSimulationSingleByIdResponse,
  PostSimulationExtendedByIdResponse,
  PostGuestSimulationStopSingleByIdResponse,
  PostGuestSimulationSingleByIdResponse,
} from '../types';

export class Sims extends Controller {
  async postSimulationStopSingleById<
    T extends PostSimulationStopSingleByIdResponse,
    D,
    C extends null
  >(
    body: C,
    { id }: PostSimulationStopSingleByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/simulation/stop/single/${id}`,
      body,
      axiosConfig
    );
  }

  async postSimulationStopExtendedById<
    T extends PostSimulationStopExtendedByIdResponse,
    D,
    C extends null
  >(
    body: C,
    { id }: PostSimulationStopExtendedByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/simulation/stop/extended/${id}`,
      body,
      axiosConfig
    );
  }

  async postSimulationSingleById<
    T extends PostSimulationSingleByIdResponse,
    D,
    C extends null
  >(
    body: C,
    { id }: PostSimulationSingleByIdParams,
    query: PostSimulationSingleByIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/simulation/single/${id}`, query),
      body,
      axiosConfig
    );
  }

  async postSimulationExtendedById<
    T extends PostSimulationExtendedByIdResponse,
    D,
    C extends null
  >(
    body: C,
    { id }: PostSimulationExtendedByIdParams,
    query: PostSimulationExtendedByIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/simulation/extended/${id}`, query),
      body,
      axiosConfig
    );
  }

  async postGuestSimulationStopSingleById<
    T extends PostGuestSimulationStopSingleByIdResponse,
    D,
    C extends null
  >(
    body: C,
    { id }: PostGuestSimulationStopSingleByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/guest/simulation/stop/single/${id}`,
      body,
      axiosConfig
    );
  }

  async postGuestSimulationSingleById<
    T extends PostGuestSimulationSingleByIdResponse,
    D,
    C extends null
  >(
    body: C,
    { id }: PostGuestSimulationSingleByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/guest/simulation/single/${id}`,
      body,
      axiosConfig
    );
  }
}
